import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const cycognito = defineConnector({
  identifier: "cycognito",
  name: "CyCognito",
  tagLine: "External exposure management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://api.platform.cycognito.com/v1"),
  auth: headerAuth([
    { name: "Authorization", value: { from: "secret", field: "apiKey" } },
  ]),
  steps: [
    {
      title: "Set up CyCognito",
      items: [
        {
          kind: "markdown",
          content:
            "Open **Workflows & Integrations → API Key Management** in CyCognito and create a key with read access. Enter it below. See the [API reference](https://api.platform.cycognito.com/v1/docs/index.html).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.platform.cycognito.com/v1",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use https://api.platform.cycognito.com/v1, or the API base URL provided for your CyCognito account.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
          helperText:
            "Create an API key in the CyCognito Platform under Workflows & Integrations → API Key Management. Select read-only access where available and copy the generated key.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://api.platform.cycognito.com/v1")
          .trim()
          .replace(/\/+$/, "") + "/realm",
      ...{ method: "GET" },
    }),
  },
});
